(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const groups = Array.from(document.querySelectorAll('.hero__random[data-hero-random-group]'));
    if (!groups.length) return;

    // Unique section IDs
    const ids = Array.from(new Set(groups.map(g => g.dataset.heroRandomGroup)));

    ids.forEach((id) => {
      const relatedGroups = groups.filter(g => g.dataset.heroRandomGroup === id);
      const first = relatedGroups[0];
      const imgsFirst = Array.from(first.querySelectorAll('[data-hero-random-img]'));
      if (imgsFirst.length <= 1) {
        relatedGroups.forEach(g => g.classList.add('is-ready'));
        return;
      }

      const key = `hero_random_${id}`;
      const last = Number(sessionStorage.getItem(key));

      let idx = Math.floor(Math.random() * imgsFirst.length);

      // Avoid repeating the same one back-to-back (within the same tab session)
      if (!Number.isNaN(last) && imgsFirst.length > 1 && idx === last) {
        idx = (idx + 1) % imgsFirst.length;
      }

      sessionStorage.setItem(key, String(idx));

      // Apply SAME idx to every group (main + blurred reflection)
      relatedGroups.forEach((group) => {
        const imgs = Array.from(group.querySelectorAll('[data-hero-random-img]'));
        imgs.forEach((img, i) => img.classList.toggle('is-active', i === idx));
        group.classList.add('is-ready');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
